import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './Icebox/Main';
import Form from './Icebox/Form';

// Utils
import {
  getDataWithComp,
  getAlert,
  getMaxIbNo,
  getCustByType,
  getClearLocalStorage
} from '../../../utils/SamuiUtils';

const Icebox = () => {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataDetailList, setDataDetailList] = useState([]);
  const [dataMasterHistoryList, setDataMasterHistoryList] = useState([]);
  const [dataDetailHistoryList, setDataDetailHistoryList] = useState([]);
  const [maxIbNo, setMaxIbNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      setMode('S');
      fetchRealtime();
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // สำหรับหน้ารายการ
      const masterList = await getCustByType('6', 'F');
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
      const detailList = await getDataWithComp('API_1002_WHDOC_D', `AND WHDocType_Name = 'Icebox' AND Item_Is_Return = 0 ORDER BY Line ASC`);
      if (detailList && detailList.length > 0) {
        setDataDetailList(detailList);
      }

      // สำหรับหน้าประวัติการยืม
      const masterHistoryList = await getCustByType('6', 'H');
      if (masterHistoryList && masterHistoryList.length > 0) {
        setDataMasterHistoryList(masterHistoryList);
      }
      const detailHistoryList = await getDataWithComp('API_1002_WHDOC_D', `AND WHDocType_Name = 'Icebox' ORDER BY Line ASC`);
      if (detailHistoryList && detailHistoryList.length > 0) {
        setDataDetailHistoryList(detailHistoryList);
      }

      // หาค่าสูงของ WHDocNo ใน WHDOC_H สำหรับ IB (ใบยืมสินค้า)
      const findMaxIbNo = await getDataWithComp('WHDoc_H', `AND WHDoc_Type = '6' ORDER BY WHDoc_No DESC`);
      const maxIb = getMaxIbNo(findMaxIbNo);
      setMaxIbNo(maxIb);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I')
  };

  const onPageUpdate = (whDocNo) => {
    setMaxIbNo(whDocNo);
    setMode('U')
  };

  return (
    <div>
      <div className="Icebox">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === 'S' ? (
                  <Main
                    name={'ใบยืมสินค้า'}
                    dataMasterList={dataMasterList}
                    dataDetailList={dataDetailList}
                    dataMasterHistoryList={dataMasterHistoryList}
                    dataDetailHistoryList={dataDetailHistoryList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(whDocNo) => onPageUpdate(whDocNo)}
                    callInitialize={() => initialize()}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    setMode={setMode}
                    name={'ใบยืมสินค้า'}
                    whDocNo={maxIbNo}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Icebox;